import React from "react";
import { Content } from "../components/content/Content";
import { makeStyles } from "@material-ui/core/styles";
import { ThemeToggle } from "../components/theme/ThemeToggle";
import { SocialIcons } from "../components/content/SocialIcons";
import { SideNavbar } from "../components/nav/SideNavbar";
import { Typography } from "@material-ui/core";
import { About } from "../components/about/About";
import { About2 } from "../components/about2/About2";
import { Contact } from "../components/contact/Contact";
import background1 from "../assets/backgroung1.jpg";

const useStyles = makeStyles((theme) => ({
  page: {
    position: "relative",
    minHeight: "100vh",
    width: "100%",
    overflowX: "hidden",
    background:
      theme.palette.type === "dark"
        ? `radial-gradient(circle at 12% 15%, ${theme.palette.primary.main}22, transparent 42%), radial-gradient(circle at 88% 20%, ${theme.palette.secondary.main}1c, transparent 45%)`
        : `radial-gradient(circle at 12% 15%, ${theme.palette.primary.main}18, transparent 42%), radial-gradient(circle at 88% 20%, ${theme.palette.secondary.main}14, transparent 45%)`,
  },
  hero: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    minHeight: "92vh",
    backgroundImage: `linear-gradient(180deg, rgba(8,11,16,0.55) 0%, rgba(8,11,16,0.82) 100%), url(${background1})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
  },
  footer: {
    marginTop: theme.spacing(6),
    padding: `${theme.spacing(4)}px ${theme.spacing(2)}px`,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: theme.spacing(1.5),
    borderTop: `1px solid ${
      theme.palette.type === "dark"
        ? "rgba(255,255,255,0.08)"
        : "rgba(0,0,0,0.08)"
    }`,
  },
  copyright: {
    color: theme.palette.text.secondary,
    fontSize: "0.85rem",
    textAlign: "center",
  },
  footerLinks: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    gap: theme.spacing(3),
  },
  footerLink: {
    color: theme.palette.text.secondary,
    textDecoration: "none",
    fontSize: "0.85rem",
    transition: "color 0.25s ease",
    "&:hover": {
      color: theme.palette.secondary.main,
    },
  },
}));

export const Home = () => {
  const classes = useStyles();

  return (
    <div className={classes.page}>
      <SideNavbar />
      <ThemeToggle />
      <SocialIcons />

      <div id="home" className={classes.hero}>
        <Content />
      </div>

      <About2 />
      <About />
      <Contact />

      <footer className={classes.footer}>
        <div className={classes.footerLinks}>
          <a href="/tos" className={classes.footerLink}>
            Terms of Service
          </a>
          <a href="/pp" className={classes.footerLink}>
            Privacy Policy
          </a>
          <a href="/pusher/privacy-policy" className={classes.footerLink}>
            PUSHER Privacy
          </a>
        </div>
        <Typography className={classes.copyright}>
          © 2020 iiCO TECK LTD. | All rights reserved.
        </Typography>
      </footer>
    </div>
  );
};
